<template lang="pug">
  .waitlist-form
    form(v-if="!joinedWaitlist && !onWaitlist" @submit.prevent="add")
      p.xs-f-xsmall.lg-f-small.max-at-tweak.text-left.upper.xs-pb-25m Email me when back in stock:
      .flex-box
        mr-input.email-input(label="Email" input-type="email" v-model="email" :v="v$.email" required)
        button.submit-btn.mr-btn.xs-f-xsmall.max-at-tweak.flex-2 sign up

    p.xs-f-xmedium.max-at-tweak(v-else role="alert") Your email has been added to the waitlist

</template>

<script>
  import { required, email } from "@vuelidate/validators";

  import { mapGetters, mapActions } from 'vuex';
  import mrInput from '../mrInput';
  import { useVuelidate } from "@vuelidate/core";

  export default {
    name: "WaitlistForm",

    components: {
      mrInput
    },

    props: {
      productId: {
        type: Number
      },
      inventoryStatus: {
        type: String,
        default: ''
      }
    },

    data() {
      return {
        email: null,
        joinedWaitlist: false
      };
    },

    validations: {
      email: {
        required,
        email
      }
    },

    setup () {
      return {
        v$: useVuelidate()
      };
    },

    computed: {
      ...mapGetters('waitlist', ['isOnWaitlist']),

      onWaitlist() {
        return this.isOnWaitlist('product_waitlist', this.productId);
      }
    },

    methods: {
      ...mapActions('waitlist', ['initWaitlists', 'addToWaitlist']),

      add() {
        if (!this.joinedWaitlist) {
          this.addToWaitlist({
            email: this.email,
            waitlist_type: 'product_waitlist',
            product_id: this.productId
          });
          this.joinedWaitlist = true;
        }
      }
    },

    created() {
      this.initWaitlists();
    }
  };
</script>

<style scoped lang="stylus">
  .waitlist-form
    .notify-text
      margin-bottom 1em

    .email-input
    .submit-btn
      display inline-block
      vertical-align top

    .email-input
      width 65%
      margin-right 0.5em
      margin-top 0

    .submit-btn
      width 30%
      padding-left 0.5em
      padding-right 0.5em
      padding-top 0.8em
      height 44px

</style>
